import axios from "axios";
import { StorageService } from "../../services";

const LOGOUT_URL = "/logout";
export const logout = () => {
  return axios.get(LOGOUT_URL).then(() => {
    StorageService.clearAll();
  });
};
